module.exports = __webpack_public_path__ + "static/Mail-Sculpt-4-45f818c75373e0d86e013153c36b363f.jpg";